export default __webpack_public_path__ + "static/media/DNo.36-1.ec5d1296.jpg";